/** PDF 페이지 이미지 API wrapper (M7-B / M7-C). */

import { apiClient } from "./client";

export interface PagesMeta {
  page_count: number;
}

export async function getPagesMeta(jobId: string, fileId: string): Promise<PagesMeta> {
  const res = await apiClient.get<PagesMeta>(`/jobs/${jobId}/files/${fileId}/pages/meta`);
  return res.data;
}

/** 단일 페이지의 PNG 를 Blob 으로 fetch.
 *
 * 호출측에서 ``URL.createObjectURL`` 로 ``<img>`` src 를 만들고
 * 컴포넌트 unmount / 페이지 변경 시 ``URL.revokeObjectURL`` 로 해제할 것.
 */
export async function getPageImageBlob(
  jobId: string,
  fileId: string,
  page: number,
  options?: { signal?: AbortSignal },
): Promise<Blob> {
  const res = await apiClient.get<Blob>(`/jobs/${jobId}/files/${fileId}/pages/${page}/image`, {
    responseType: "blob",
    signal: options?.signal,
  });
  return res.data;
}

/** 원본 PDF 다운로드 URL — toolbar 의 ↓ PDF 버튼이 새 탭으로 열거나 download.
 *
 * 주의: 이 URL 은 인증 헤더 없이는 401 — 다운로드 버튼은 ``apiClient`` 로 blob 받아
 * ObjectURL anchor 클릭하는 방식을 사용한다 (file_images 의 downloadPdf 헬퍼).
 */
export async function downloadPdfBlob(jobId: string, fileId: string): Promise<Blob> {
  const res = await apiClient.get<Blob>(`/jobs/${jobId}/files/${fileId}/pdf`, {
    responseType: "blob",
  });
  return res.data;
}
